import React, {Component} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {injectRoute} from "@irati/utils/helpers/routing"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import authentication from "@irati/auth"
import Notify from "@irati/utils/notify"
import {createScheduleWithDefaults} from "@irati/insights/services/schedule"
import sitemap from "../../routes/sitemap"
import tracking from "../../tracking/survey"

class CreateScheduleButton extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  static defaultProps = {
    children: null
  }

  static contextTypes = {
    appPath: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.idNamespace = id("CreateScheduleButton", this.props)
    this.state = {
      load: null
    }
  }

  handleClick = () => {
    const load = createScheduleWithDefaults(authentication.userTenant().uuid)
      /** Return the URL to redirect to */
      .then((scheduleId) => injectRoute(sitemap.scheduleSettings.url, {scheduleId}))
      .catch((err) => {
        tracking.errorsEmployeeEngagement()
        Notify.error({
          message: err.message,
          position: "bottom-right"
        })
      })

    this.setState({load})

    return load
  }

  render() {
    const {load} = this.state

    return (
      <ButtonRouterLink {...this.props} async id={this.idNamespace} load={load} onClick={this.handleClick}>
        {this.props.children}
      </ButtonRouterLink>
    )
  }
}

export default CreateScheduleButton
